module.exports = __webpack_public_path__ + "static/img/20220610_01.6cadf42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/20220610_01.png
// module id = OSg3
// module chunks = 0